(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pair-with"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var selectors = {
      section: '[data-pair-with-root]',
      item: '[data-pair-with-item]',
      carousel: '[data-pair-with-carousel]',
      slide: '[data-pair-with-slide]',
      prev: '[data-pair-with-prev]',
      next: '[data-pair-with-next]',
    };

    function initItem(item) {
      if (item.dataset.pairWithItemReady === 'true') return;
      item.dataset.pairWithItemReady = 'true';

      var carousel = item.querySelector(selectors.carousel);
      var slides = carousel ? Array.from(carousel.querySelectorAll(selectors.slide)) : [];
      var prevButton = carousel ? carousel.querySelector(selectors.prev) : null;
      var nextButton = carousel ? carousel.querySelector(selectors.next) : null;

      if (!carousel || !slides.length) return;

      var currentIndex = slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });

      if (currentIndex < 0) currentIndex = 0;

      var update = function () {
        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        if (prevButton) prevButton.disabled = currentIndex === 0;
        if (nextButton) nextButton.disabled = currentIndex === slides.length - 1;
      };

      if (slides.length <= 1 || !prevButton || !nextButton) {
        update();
        return;
      }

      prevButton.addEventListener('click', function () {
        currentIndex = Math.max(0, currentIndex - 1);
        update();
      });

      nextButton.addEventListener('click', function () {
        currentIndex = Math.min(slides.length - 1, currentIndex + 1);
        update();
      });

      update();
    }

    async function fetchRecommendations(section) {
      if (section.dataset.fetching === 'true' || !section.dataset.recommendationsUrl) return;
      section.dataset.fetching = 'true';

      try {
        var response = await fetch(section.dataset.recommendationsUrl, {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) {
          throw new Error('Pair With request failed with status ' + response.status);
        }

        var html = await response.text();
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var selector =
          selectors.section +
          '[data-section-id="' +
          section.dataset.sectionId +
          '"][data-block-id="' +
          section.dataset.blockId +
          '"]';
        var replacement = documentFragment.querySelector(selector);

        if (replacement) {
          section.replaceWith(replacement);
          initSection(replacement);
          return;
        }
      } catch (error) {
        console.error('Pair With recommendations error:', error);
      }

      if (section.dataset.hasCards !== 'true' && section.dataset.hideWhenEmpty === 'true') {
        section.hidden = true;
      }

      section.dataset.fetching = 'false';
    }

    function initSections(scope) {
      var root = scope || document;
      var sections = [];

      if (root instanceof HTMLElement && root.matches(selectors.section)) {
        sections.push(root);
      }

      if (root.querySelectorAll) {
        sections = sections.concat(Array.from(root.querySelectorAll(selectors.section)));
      }

      sections.forEach(function (section) {
        initSection(section);
      });
    }

    function initSection(section) {
      if (!section || section.dataset.pairWithInitialized === 'true') return;
      section.dataset.pairWithInitialized = 'true';

      section.querySelectorAll(selectors.item).forEach(function (item) {
        initItem(item);
      });

      if (section.dataset.fetchRecommendations === 'true') {
        fetchRecommendations(section);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initSections(document);
      });
    } else {
      initSections(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!(event.target instanceof HTMLElement)) return;
      initSections(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
